/* global jQuery MicroModal */
import Accordion from 'accordion-js'
// import 'accordion-js/dist/accordion.min.css'
;(function ($) {
  // 1. inject the micromodal wrapper
  const wrapper = document.createElement('div')
  wrapper.setAttribute('id', 'footer-pages')
  wrapper.setAttribute('aria-hidden', 'true')
  wrapper.setAttribute('class', 'micromodal-footer-wrapper is-loading')
  wrapper.innerHTML = `
  <div tabindex="-1" class="micromodal-footer-overlay">
    <div
      role="dialog"
      aria-modal="true"
      aria-label="mobile site menu"
      class="micromodal-footer-dialog"
    >
      <button aria-label="close modal" class="micromodal-footer-close" data-micromodal-close></button>
      <div class="micromodal-footer-content" id="micromodal-footer-content"></div>
    </div>
  </div>
`
  document.body.appendChild(wrapper)

  let trap = focusTrap.createFocusTrap('#footer-pages', {
    initialFocus: false,
    escapeDeactivates: false,
    clickOutsideDeactivates: false,
    returnFocusOnDeactivate: false
  })

  let restore = null
  let accordion = null
  let isLoaded = false

  // 2. footer links trigger AJAX => MODAL
  $('footer a:not([target])')
    .attr('role', 'button')
    .attr('haspopup', 'true')
    .on('click', function (e) {
      e.preventDefault()
      if (!isLoaded) {
        $('#micromodal-footer-title').text($(this).text())
        $('#micromodal-footer-content').load(
          $(this).attr('href') + '#page-content .detail-body',
          function (response, status, xhr) {
            $('#footer-pages').removeClass('is-loading')

            const container = document.querySelector('.accordion-container')

            // need an array of indexes of items to be opened initially.
            // filter() would reset the array indexes, so first map()
            // an object with the element + index, then filter() the
            // open ones, then map() those indexes back to an array
            const isOpen = Array.from(container.children)
              .map((el, i) => ({ i: i, el: el }))
              .filter(obj => obj.el.hasAttribute('data-open'))
              .map(obj => obj.i)

            // init accordion
            accordion = new Accordion(container, {
              duration: 250,
              showMultiple: true,
              openOnInit: isOpen
            })

            isLoaded = true
          }
        )
      }

      MicroModal.show('footer-pages', {
        onShow: modal => {
          trap.activate()
          const dialog = modal.querySelector('div[role="dialog"]')
          restore = hideOthers(dialog)
        },
        onClose: modal => {
          trap.deactivate()
          restore()
          e.target.focus()
        },
        openTrigger: 'data-footer-pages-open',
        awaitOpenAnimation: true,
        awaitCloseAnimation: true
      })
    })
})(jQuery)
